"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SoundCloudSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.5,6 C11.9445388,6 13.184683,6.87511708 13.7191982,8.12411668 C15.7318573,7.55907922 17,9.11928813 17,10.5 C17,11.8254834 15.9952553,13 14.5,13 C13.0587674,13 10.8921007,13 8,13 L7.9999017,7.05089169 C8.6350217,6.4023412 9.52052494,6 10.5,6 Z M5,8.76471656 L5,13 L4,13 L4,9 C4,8.77397156 4.83381321,8.76471656 5,8.76471656 Z M7.00151619,8.05031732 L7,13 L6,13 L5.99951464,8.05010637 C6.16121197,8.01725046 6.83949129,8.01732302 7.00151619,8.05031732 Z M2.99992752,9.26760632 L2.99992752,12.7323937 C2.40216612,12.3865739 2,11.7402524 2,11 C2,10.2597476 2.40216612,9.61342606 2.99992752,9.26760632 Z" })));
};
SoundCloudSmall.displayName = 'SoundCloudSmall';
exports.default = SoundCloudSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SoundCloudSmall.js.map